import * as Yup from 'yup'

export const createMyAirdropWalletFormValidationSchema = () => {
    return Yup.object().shape({
        chain: Yup.string().required('Chain is required'),
        address: Yup.string().required('Wallet address is required'),
    })
}